import { render, staticRenderFns } from "./NewRoute.vue?vue&type=template&id=ef183a1a&scoped=true"
import script from "./NewRoute.vue?vue&type=script&lang=js"
export * from "./NewRoute.vue?vue&type=script&lang=js"
import style0 from "./NewRoute.vue?vue&type=style&index=0&id=ef183a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef183a1a",
  null
  
)

export default component.exports